import { Component, AfterViewChecked } from '@angular/core';
import { DataService } from '@core/services';
import { faBan } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false
})
export class HomeComponent implements AfterViewChecked {
  imagePath: any;
  faBan = faBan;
  _contractorName?: string;

  constructor(public DataService: DataService) { }

  ngAfterViewChecked(): void {
    this._contractorName = JSON.parse(sessionStorage.getItem('HIPContract'))?.contractorName;
  }

  recieveLogo(logo: string) {
    if(logo) {
      this.imagePath = logo;
    } else {
      this.imagePath = false;
    }
  }
}
